import { PROFFIT_CONTACT_ILLUSTRATION_CASUAL, PROFFIT_CONTACT_ILLUSTRATION_CONSULTANT, PROFFIT_CONTACT_ILLUSTRATION_OTHER, } from '@/utils/constants/assets/s3';
import { contactCasualPath, contactConsultationPath, contactOtherPath, } from '@/utils/router/links';
/** お問い合わせの表示内容 */
export const contactTypeListItems = [
    {
        button: {
            text: '予約する',
            to: contactCasualPath(),
        },
        description: 'コンサル活用を前提とせず、進め方や費用水準、社内承認の進め方などの、不安や疑問におこたえします。',
        head: 'カジュアル相談会（30分）',
        image: {
            src: PROFFIT_CONTACT_ILLUSTRATION_CASUAL.base,
        },
    },
    {
        button: {
            text: '予約する',
            to: contactConsultationPath(),
        },
        description: 'コンサル選定に向けてヒアリングを実施し、活用のアドバイスをしながら、依頼事項を明確に整理します。',
        head: 'コンサル選定のご相談（1時間）',
        image: {
            src: PROFFIT_CONTACT_ILLUSTRATION_CONSULTANT.base,
        },
    },
    {
        button: {
            text: '問い合わせる',
            to: contactOtherPath(),
        },
        description: 'サービスに関する質問や、調達部門の方のご利用方法、取材やメディア掲載に関するお問い合わせはこちら。',
        head: 'その他のお問い合わせ',
        image: {
            src: PROFFIT_CONTACT_ILLUSTRATION_OTHER.base,
        },
    },
];
